import { apiC2, apiNGS } from '../../config/api'
import { createUserMIPYME } from '../../config/apiSinToken'

export const createForm = (form) => {
  return apiNGS.post(`api/v1/Forms/InsertFormPreElegibility`, form)
}

export const createMiForm = (form) => {
  return apiNGS.post(`api/v1/MiPymes/Register`, form)
}

export const updateForm = (form) => {
  return apiC2.post(`preelegibility/updateform`, form)
}

export const createUser = (userInfo) => {
  return createUserMIPYME(`api/v1/Users/InsertMiPymeUserWithoutIFI`, userInfo)
}

export const validateEditForm = (B2C, IdAction, IdFormAnswer) => {
  return createUserMIPYME(
    `api/v1/Forms/ValidateEditForm/${B2C}/${IdAction}?IdFormAnswer=${IdFormAnswer}`,
  )
}

export const infoValidateEditForm = (B2C, IdFormAnswer) => {
  return createUserMIPYME(
    `api/v1/Forms/infoValidateEditForm?IdUserAzureB2C=${B2C}&IdFormAnswer=${IdFormAnswer}`,
  )
}

export const createMiFormByIFI = (form) => {
  return apiNGS.post(`api/v1/MiPymes/Register/ExistingUser`, form)
}
